module.exports = __webpack_public_path__ + "img/deane.74d9ba69.jpg";